'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _tabs = require('antd/lib/tabs');

var _tabs2 = _interopRequireDefault(_tabs);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TabsComponent(props) {
	var className = (0, _classnames2.default)((0, _defineProperty3.default)({
		'mk-tabs': true
	}, props.className, !!props.className));
	return _react2.default.createElement(_tabs2.default, (0, _extends3.default)({}, props, { className: className }));
}

TabsComponent.TabPane = _tabs2.default.TabPane;

exports.default = TabsComponent;
module.exports = exports['default'];